export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    borderColor: state.isFocused ? "#007bff" : "#ccc",
    boxShadow: state.isFocused ? "0 0 0 1px #007bff" : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#007bff" : "#aaa",
    },
    borderRadius: "8px",
    minHeight: "40px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "#e9ecef"
      : state.isSelected
      ? "#007bff"
      : "#fff",
    color: state.isSelected ? "#fff" : "#333",
    "&:active": {
      backgroundColor: "#007bff",
      color: "#fff",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    border: "1px solid #ccc",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e6f0ff",
    borderRadius: "15px",
    padding: "2px 8px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#007bff",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#007bff",
    "&:hover": {
      backgroundColor: "#007bff",
      color: "white",
    },
  }),
};
